import React from 'react';
import Val from '../../ui/Val';
import Obtainer from '../../helpers/Obtainer';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Entrance from "../Entrance";

export default class PanelAccount extends React.Component {

  OBTAIN = {
    ACCOUNT_INFO:   'accountInfo',
  }

  singleObtainQueriesDone = {};
  id_waitForObtain = null;

  constructor(props) {
    super(props);

    this.state = {
      avatarUrl : "",
      username: 'Obtaining account info...',
      followers_count: '?',
      followings_count: '?',
      showReauthorizeButton: false
    };

    Obtainer.mixin(PanelAccount);

    this.bindPeriodicalObtain(
      this.OBTAINS().ACCOUNT_INFO,
      null,
      (data)=>{
        this.setState({avatarUrl: data['avatar_url'].replace("large", 't500x500')});
        this.setState({username: data['username']});
        this.setState({followers_count: data['followers_count']});
        this.setState({followings_count: data['followings_count']});
        this.setState({user_id: data['followings_count']});
        this.setState({sc_v1_exist: data['followings_count']});
      },
      (error)=>{
      },
      60
      );
  }

  componentWillMount(){

  }

  componentDidMount() {
    this.startObtain(this.OBTAINS().ACCOUNT_INFO);
    fetch('https://staging.soundcloudhelper.com/SCH_Setting.php?id_account='+Entrance.accountId())
        .then(response => response.json())
        .then(data => {

          if((data.have_v1!=data.have_v2) && (data.button_Reauthorize_Account=="on"))
          {
            this.setState({
              showReauthorizeButton: true,
            });
          }

          if(data.have_v1)
          {
            localStorage.setItem('RA',"v2");
          }
          if(data.have_v2)
          {
            localStorage.setItem('RA',"v1");
          }

          //define mode version work SCH V1 or V2 for better validation in
            // src/components/pages/panels/PanelOptions.js line 18 23 28
            // if()
            // {
            //
            // }

        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
  }



  componentWillUnmount(){
    this.cancelObtain(this.OBTAINS().ACCOUNT_INFO);
  }

  handleReauthorizeClick () {
    // window.open('https://www.soundcloud.com/connect?client_id=bkm02pBREf015hWbZoRusR8PUMBaHUk1&display=popup&response_type=code&redirect_uri=https%3A%2F%2Fexcitr.io%2Fcallback.html&state='+localStorage.IDUser);
    window.open('https://www.schelper.co/web-sch/link_account?RA='+localStorage.RA);

  };
  render() {
    return (
      <div className="panel-account__wrapper component-bottom-margin">
        <div className="panel-account">
          <Container>
            <Row className='justify-content-xs-left'>
              <Col xs="12" xl="3"> 
                <img src={this.state.avatarUrl} className="panel-account-avatar" />
              </Col>
              <Col xs="12" xl="3">
                <h1>{this.state.username}</h1>
                <div className="panel-account-desc">
                  Follower(s): {this.state.followers_count} <br/>
                  Following(s): {this.state.followings_count}
                </div>
              </Col>
              <Col xs="12" xl="6" className="panel-account-reauthorize">
                {this.state.showReauthorizeButton && (
                <button  onClick={this.handleReauthorizeClick}>Reauthorize Account</button>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }







}
